import moment from 'moment';

require('./speech-recognition-results.scss');


const PULL_MIN_DELAY = 1000;
const PULL_MID_DELAY = 5000;
const PULL_MAX_DELAY = 15000;
const RESULTS_REQ_LIMIT = 20;
const RESULTS_LST_LIMIT = 30;
// порядок зависит от backend-а, `message` опционально
const RESULT_KEYS = [
  'id', 'status', 'updated_timestamp', 'attempts',
  'audio_duration', 'recognized_duration',
  'transcript', 'message', 'event_timestamp',
];


class SpeechRecognitionResultsController {
  constructor($scope, $timeout, $http, $cookies) {
    this.$timeout = $timeout;
    this.$http = $http;
    this.$cookies = $cookies;
    this.results = [];
  }

  $onInit() {
    this.pull_delay = 500;
    this.schedulePull();
  }

  $onDestroy() {
    this.destroyed = true;
    if (angular.isDefined(this.pull_promise)) {
      this.$timeout.cancel(this.pull_promise);
      delete this.pull_promise;
    }
  }

  schedulePull(error) {
    if (error) { this.pull_delay *= 1.5; }

    if (PULL_MAX_DELAY < this.pull_delay) { this.pull_delay = PULL_MAX_DELAY; } else
    if (this.pull_delay < PULL_MIN_DELAY) { this.pull_delay = PULL_MIN_DELAY; }

    if (angular.isDefined(this.pull_promise)) {
      this.$timeout.cancel(this.pull_promise);
    }
    if (!this.destroyed) {
      this.pull_promise = this.$timeout(this.pullResults.bind(this), this.pull_delay);
    }
  }

  pullResults() {
    if (this.filter.id) {
      let url = '/speech_processing/results?timeout=15000' +
        `&filter_id=${this.filter.id}` +
        `&limit=${RESULTS_REQ_LIMIT}`;

      if (this.results.length) {
        let max_time = Math.max(...[0].concat(this.results.map((item) => item.updated_timestamp)));
        url += `&after_time=${max_time}&latest`;
      }

      this.$http.get(url,
          {headers: {
            'Accept': 'application/json;charset=utf-8',
            'X-CSRFToken': this.$cookies.get('csrftoken'),
          }})
      .then((response) => {
        if (response.data && angular.isArray(response.data.results)) {
          if (this.pushResults(response.data.results)) {
            this.pull_delay = PULL_MIN_DELAY;
          } else {
            this.pull_delay = PULL_MID_DELAY;
          }
          this.schedulePull();
        } else {
          console.error('Unknown response:', response.data);
          this.schedulePull(true);
        }
      })
      .catch((error) => {
        this.schedulePull(true);

        let message = angular.isString(error.data)
          ? error.data
          : angular.isObject(error.data) && angular.isString(error.data.message)
          ? error.data.message
          : error;

        console.error(message);
      });
    }
  }

  pushResults(results) {
    let changes = 0;
    let result_ids = {};

    for (let [idx, result] of this.results.entries()) {
      result_ids[result.id] = idx;
    }

    Object.assign(this.results, results.map((row) => {
      let result = {};

      for (let [idx, key] of RESULT_KEYS.entries()) {
        if (row.length <= idx) { break }
        result[key] = row[idx];
      }

      if (angular.isDefined(result.recognized_duration) && result.audio_duration < result.recognized_duration) {
        result.recognized_duration = result.audio_duration;
      }

      let idx = result_ids[result.id];
      let old_result = this.results[idx];

      if (old_result) {
        old_result = RESULT_KEYS.reduce((map, key) => {
          map[key] = old_result[key];
          return map;
        }, {});

        if (!angular.equals(result, old_result)) {
          this.results.splice(idx, 1);
          changes++;
        } else {
          result = undefined;
        }
      } else {
        changes++;
      }

      if (result && result.updated_timestamp) {
        result.updated_at = moment(result.updated_timestamp);
      }

      if (result && result.event_timestamp) {
        result.event_time = moment(result.event_timestamp);
      }

      return result;
    })
    .filter((result) => angular.isDefined(result))
    .concat(this.results)
    .sort((left, right) => (right.updated_timestamp - left.updated_timestamp)));

    if (RESULTS_LST_LIMIT < this.results.length) {
      this.results.splice(RESULTS_LST_LIMIT + 1);
      changes++;
    }

    return 0 < changes;
  }
}


export const SpeechRecognitionResultsComponent = {
  restrict    : 'E',
  template    : require('./speech-recognition-results.html'),
  controller  : SpeechRecognitionResultsController,
  bindings    : {filter: '<'},
}



// WEBPACK FOOTER //
// ./src/speech/speech-recognition-results.js